'use client'
import { HTMLProps } from 'react'
import { useTranslations } from 'next-intl'
import { Button } from '@/shared/ui'
import { usePopoverContext } from '@/shared/ui/popover'
import style from './date-picker.module.scss'

interface ActionFooterProps extends HTMLProps<HTMLButtonElement> {
  onReset: () => void
}

export const ActionFooter = (props: ActionFooterProps) => {
  const { onClick, disabled, onReset } = props
  const { setOpen } = usePopoverContext()
  const calendarButtons = useTranslations('CalendarButtons')

  return (
    <div className={style.footer}>
      <Button
        className={style.button}
        type="outline"
        size="l"
        onClick={() => {
          onReset()
          setOpen(false)
        }}
      >
        {calendarButtons('reset')}
      </Button>
      <Button
        className={style.button}
        type="outline"
        size="l"
        onClick={event => {
          onClick?.(event)
          setOpen(false)
        }}
        disabled={disabled}
      >
        {calendarButtons('apply')}
      </Button>
    </div>
  )
}
